export function isChunkLoadError(error: unknown): boolean {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    const name = error.name.toLowerCase();
    return (
      name === "chunkloaderror" ||
      message.includes("loading chunk") ||
      message.includes("failed to fetch dynamically imported module") ||
      message.includes("importing a module script failed") ||
      message.includes("error loading dynamically imported module")
    );
  }

  if (typeof error === "string") {
    const message = error.toLowerCase();
    return (
      message.includes("loading chunk") ||
      message.includes("chunkloaderror") ||
      message.includes("failed to fetch dynamically imported module")
    );
  }

  return false;
}

export function getErrorMessage(error: unknown): string {
  if (isChunkLoadError(error)) {
    return "The application was updated or this page failed to load. Refresh the page to continue.";
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  if (typeof error === "string" && error.trim()) {
    return error;
  }

  return "Something went wrong. Please try again.";
}
